import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Form.module.css";
import api from "../../Utils/Network";

const Form = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    const fetchTokens = async () => {
      const storedAccessToken = localStorage.getItem("access_token");
      if (storedAccessToken) {
        setIsLoading(false);
        return;
      }

      const params = new URLSearchParams(location.search);
      const code = params.get("code");

      if (!code) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.get(`/auth/callback?code=${code}`, {
          signal: controller.signal,
        });

        const { access_token, refresh_token } = response.data;

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);

        navigate("/form");
      } catch (error) {
        if (error?.code === "ERR_CANCELED") {
          console.log("Request was canceled");
        } else if (error?.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          console.error("Error response headers:", error.response.headers);
        } else if (error?.request) {
          console.error("Error request:", error.request);
        } else {
          console.error("Error message:", error?.message);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchTokens();

    // ✅ Proper cleanup for React effect
    return () => controller.abort();
  }, [location.search, navigate]);

  if (isLoading) {
    return (
      <div>
        <div className={styles.formWarpper}>
          <p className={styles.loadingtext}>Loading...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default Form;
